export const employeesRangeMap = {
  '-1': 'unknown',
  '1': ':1',
  '5': '2:5',
  '10': '6:10',
  '20': '11:20',
  '50': '21:50',
  '100': '51:100',
  '250': '101:250',
  '500': '251:500',
  '1000': '501:1000',
  '2500': '1001:2500',
  '5000': '2501:5000',
  '10000': '5001:10000',
  '10000000': '10001:'
};

export const revenueRangeMap = {
  '-1': 'unknown',
  '100': ':100000',
  '500': '100000:500000',
  '1000': '500000:1000000',
  '2000': '1000000:2000000',
  '5000': '2000000:5000000',
  '10000': '5000000:10000000',
  '25000': '10000000:25000000',
  '50000': '25000000:50000000',
  '100000': '50000000:100000000',
  '250000': '100000000:250000000',
  '500000': '250000000:500000000',
  '10000000': '500000000:'
};
